/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hide_On_StartupInputs */



/**
* | output |
* | --- |
* | "Hide on startup" |
*
* @param {Hide_On_StartupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const hide_on_startup = /** @type {((inputs?: Hide_On_StartupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hide_On_StartupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer au démarrage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Start ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi all'avvio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть при запуске")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar al iniciar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启动时隐藏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("起動時に非表示にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टार्टअप पर छिपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocultar na inicialização")
	return /** @type {LocalizedString} */ ("Hide on startup")
});